// Layout.tsx
import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import classes from "./Layout.module.css";
import { t } from "i18next";
import { countrySupportMap } from "../../constants";

export const Layout: React.FC = () => {
  const navigate = useNavigate();
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = "/files/Project Atlantis Wireframes.pdf"; // or '/your-file.xlsx' for Excel
    link.download = "notification.pdf"; // or 'file.xlsx' for Excel
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const savedCountry = sessionStorage.getItem("country") ?? "";
  const CountryData = countrySupportMap[savedCountry];

  return (
    <div className={classes.layoutContainer}>
      <div className={classes.mainContent}>
        <h1 className={classes.title}>{t("welcome")}</h1>
        <button
          className={classes.backButton}
          onClick={() => {
            navigate("/");
            // sessionStorage.removeItem("country");
          }}
        >
          ← {t("common.back_home")}
        </button>
        <Outlet />
      </div>
      <aside className={classes.sidebar}>
        <div
          className={classes.downloadContainer}
          // onClick={handleDownload}
          // role="button"
          // tabIndex={0}
          // onKeyPress={(e) => {
          //   if (e.key === "Enter") handleDownload();
          // }}
        >
          {/* <img
            src="/images/pdf.png"
            alt="Download PDF"
            className={classes.downloadImage}
          /> 
          <div className={classes.downloadText}>
            {t("layout.download_text")}
          </div>*/}
        </div>
        <p className={classes.infoText}>
          {t("layout.information_text")}
          <span style={{ whiteSpace: "nowrap", fontWeight: 600 }}>
            {CountryData.phone || CountryData.email}.
          </span>
        </p>
      </aside>
    </div>
  );
};
